export default "__VITE_ASSET__3264539c__"